import { jsx as _jsx } from "react/jsx-runtime";
import { toast, Slide } from "react-toastify";
import ErrorToastContent from "./ErrorToastContent";
import { stliteStyledPromiseToast } from "./promise";
export function makeToastKernelCallbacks(options) {
    const { disableProgressToasts = false, disableErrorToasts = false } = options ?? {};
    let prevToastId = null;
    const toastIds = [];
    const onProgress = (message) => {
        if (disableProgressToasts) {
            return;
        }
        const id = toast(message, {
            position: "bottom-right",
            transition: Slide,
            isLoading: true,
            hideProgressBar: true,
            closeButton: false,
        });
        toastIds.push(id);
        if (prevToastId) {
            toast.update(prevToastId, {
                isLoading: false,
                autoClose: 3000,
            });
        }
        prevToastId = id;
    };
    const onLoad = () => {
        toastIds.forEach((id) => toast.dismiss(id));
    };
    const onError = (error) => {
        if (disableErrorToasts) {
            return;
        }
        toast(_jsx(ErrorToastContent, { message: "Error during booting up", error: error }), {
            position: "bottom-right",
            type: "error",
            autoClose: false,
            closeOnClick: false,
        });
    };
    const onModuleAutoLoad = (packagesToLoad, installPromise) => {
        stliteStyledPromiseToast(installPromise, {
            success: {
                render({ data }) {
                    return `Auto-loaded${data ? ": " + data.map((pkg) => pkg.name).join(", ") : " packages"}`;
                },
            },
            error: "Failed to auto-load packages",
            pending: "Auto-loading packages",
        });
    };
    return {
        onProgress,
        onLoad,
        onError,
        onModuleAutoLoad,
    };
}
//# sourceMappingURL=callbacks.js.map